class PickupAvailability extends HTMLElement {
  constructor() {
    super();

    const templateNode = this.querySelector("template");
    this.errorHtml = templateNode?.content?.firstElementChild
      ? templateNode.content.firstElementChild.cloneNode(true)
      : null;

    this.stockEndpoint = (this.dataset.stockEndpoint || "").trim();
    this.stockEndpointLocal = (this.dataset.stockEndpointLocal || "").trim();
    this.onClickRefreshList = this.onClickRefreshList.bind(this);

    if (
      this.stockEndpoint &&
      this.stockEndpointLocal &&
      ["127.0.0.1", "localhost"].includes(window.location.hostname)
    ) {
      this.stockEndpoint = this.stockEndpointLocal;
    }

    if (this.stockEndpoint) {
      // Render a clickable drawer immediately, then hydrate with live stock.
      this.renderExternalPreview({ locations: [] });
      this.fetchExternalAvailability(this.dataset.variantId);
      return;
    }

    if (!this.hasAttribute("available")) {
      if (this.errorHtml) {
        this.renderPreview(this.errorHtml);
      }
      return;
    }

    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const rootUrl = !this.dataset.rootUrl.endsWith("/")
      ? `${this.dataset.rootUrl}/`
      : this.dataset.rootUrl;

    const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

    fetch(variantSectionUrl)
      .then((response) => {
        console.log(response);
        return response.text();
      })
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        const button = this.querySelector("button");

        if (button)
          button.removeEventListener("click", this.onClickRefreshList);

        this.renderError();
      });
  }

  onClickRefreshList(event) {
    if (this.stockEndpoint) {
      this.fetchExternalAvailability(this.dataset.variantId);
      return;
    }
    this.fetchAvailability(this.dataset.variantId);
  }

  renderError() {
    if (this.stockEndpoint) {
      this.renderExternalPreview({ locations: [] });
      return;
    }

    if (!this.errorHtml) return;
    this.innerHTML = "";
    this.appendChild(this.errorHtml);
    this.querySelector("button")?.addEventListener(
      "click",
      this.onClickRefreshList
    );
  }

  fetchExternalAvailability(variantId) {
    if (!this.stockEndpoint || !variantId) {
      this.renderError();
      return;
    }

    const separator = this.stockEndpoint.includes("?") ? "&" : "?";
    const url = `${this.stockEndpoint}${separator}variant_id=${encodeURIComponent(
      variantId
    )}`;

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Stock endpoint error: ${response.status}`);
        }
        return response.json();
      })
      .then((payload) => {
        this.renderExternalPreview(payload);
      })
      .catch(() => {
        this.renderError();
      });
  }

  renderExternalPreview(payload) {
    const locations = Array.isArray(payload?.locations)
      ? payload.locations.filter(
          (store) => (store?.location_name || "").trim().toLowerCase() !== "lutz lager"
        )
      : [];
    const storesHtml = locations.length
      ? locations
          .map((store) => {
            const available = Number(store?.available || 0);
            const inStock = available > 0;
            const statusText = inStock
              ? `Noch ${available} an Lager`
              : "Zurzeit nicht an Lager";
            const statusClass = inStock
              ? "pickup-availability-store__preview--in-stock"
              : "pickup-availability-store__preview--out-of-stock";

            return `
              <li class="pickup-availability-store" data-location-name="${(store.location_name || "").toLowerCase()}">
                <p class="pickup-availability-store__title">${store.location_name || ""}</p>
                <p class="pickup-availability-store__preview ${statusClass}">
                  <span class="pickup-availability-store__dot" aria-hidden="true"></span>
                  ${statusText}
                </p>
              </li>
            `;
          })
          .join("")
      : `
        <li class="pickup-availability-store">
          <p class="pickup-availability-store__title">Keine Filialdaten verfügbar</p>
          <p class="pickup-availability-store__preview pickup-availability-store__preview--out-of-stock">
            Filialbestände konnten nicht geladen werden.
          </p>
        </li>
      `;

    this.innerHTML = `
      <pickup-availability-preview class="pickup-availability-preview pickup-availability-preview--external">
        <menu-drawer class="pickup-availability__drawer drawer">
          <details id="Pickup-Availability-drawer" class="drawer__container">
            <summary class="drawer__button section__drawer-button">
              <button type="button" class="button button--text button--uppercase">
                Verfügbarkeit in Filialen prüfen
              </button>
            </summary>
            <div class="drawer__content js-drawer" id="Pickup-Availability-menu-drawer" tabindex="-1">
              <button
                class="drawer__button-close button-reset no-js-hidden js-btn-close-drawer"
                aria-label="Close"
                aria-controls="Pickup-Availability-menu-drawer"
                aria-expanded="false"
              >
                ×
              </button>
              <div class="drawer__row drawer__row--gutter-sm">
                <h2 class="drawer__title heading-static">Filialen Verfügbarkeit prüfen</h2>
                <div class="pickup-availability-external__note">
                  Bei niedrigem Bestand kontaktieren Sie bitte die Filiale, um sicherzugehen, dass das gewünschte Produkt vor Ort tatsächlich vorhanden ist.
                </div>
                <ul class="pickup-availability-stores list-unstyled" role="list">
                  ${storesHtml}
                </ul>
              </div>
            </div>
          </details>
        </menu-drawer>
      </pickup-availability-preview>
    `;

    this.setAttribute("available", "");
  }

  renderPreview(sectionInnerHTML) {
    if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
      this.innerHTML =
        '<span class="nicht-verfügbar" >In keiner Filiale Verfügbar</span>';
      this.removeAttribute("available");

      return;
    }

    /*
    this.innerHTML = sectionInnerHTML.querySelector(
      "pickup-availability-preview"
    ).outerHTML;
    this.setAttribute("available", "");
    */

    const previewEl = sectionInnerHTML.querySelector(
      "pickup-availability-preview"
    );

    console.log("________________");
    console.log(previewEl);

    if (previewEl) {
      // Title & Meta verstecken
      const titleEl = previewEl.querySelector(
        ".pickup-availability__info-title"
      );
      const metaEl = previewEl.querySelector(".pickup-availability__info-meta");
      if (titleEl) titleEl.style.display = "none";
      if (metaEl) metaEl.style.display = "none";

      // Button-Text ersetzen
      const buttonEl = previewEl.querySelector(".drawer__button button");
      if (buttonEl) {
        buttonEl.textContent = "Verfügbarkeit im Store prüfen";
      }

      // Optional: Du kannst auch Klassen anpassen, falls du später eigenes Styling willst
      // previewEl.classList.add("pickup-availability--custom");

      // Jetzt das fertige HTML einsetzen
      this.innerHTML = "";
      this.appendChild(previewEl);
      this.setAttribute("available", "");
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);
